import React from 'react';
import User from './User';
import ContentView from '../../Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <User />
        </ContentView>
    );
};
export default index;
